import { createFileRoute } from '@tanstack/react-router';
import { ServiceTypesPage } from '@/pages/settings/ServiceTypesPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/settings/service-types')({
	beforeLoad: ({ context }) => requireAnyPermission({ context, anyOf: ['companySettings.manageServiceTypes'] }),
	component: ServiceTypesPage,
});
